import { render, staticRenderFns } from "./MonitorsDashboardCategory.vue?vue&type=template&id=05720184&"
import script from "./MonitorsDashboardCategory.vue?vue&type=script&lang=js&"
export * from "./MonitorsDashboardCategory.vue?vue&type=script&lang=js&"
import style0 from "./MonitorsDashboardCategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports